<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6" class="flex">
        <span>订单编号：</span>
        <el-input v-model="search.orderNum" placeholder="请输入订单编号"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>订单状态：</span>
        <el-select v-model="search.orderState" placeholder="请选择" clearable style="width:100%">
          <el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>创建日期：</span>
        <el-date-picker v-model="search.activityTimeDataArr" type="datetimerange" range-separator="至"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始日期" end-placeholder="结束日期" :disabled="isEdit" style="width:100%">
        </el-date-picker>
      </el-col>
      <el-col :span="6" class="flex">
        <span>联系电话：</span>
        <el-input v-model="search.yddh" placeholder="请输入手机号"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg">
      <el-col :span="6" class="flex">
        <span>预约日期：</span>
        <el-date-picker v-model="search.appointmentTimeDataArr" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" 
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        :disabled="isEdit" style="width:100%">
        </el-date-picker>
      </el-col>
      <el-col :span="6" class="flex">
        <span style="flex:1">合作方名称：</span>
        <el-input v-model="search.partnerName" placeholder="请输入合作方名称" :disabled="isDisabledPartnerCondition"></el-input>
      </el-col>
      <el-col :span="6" class="flex">
        <span>合作类型：</span>
        <el-select v-model="search.partnershipType" placeholder="请选择" clearable style="width:100%" :disabled="isDisabledPartnerCondition">
          <el-option label="子公司" :value="1" style="width:100%"></el-option>
          <el-option label="第三方" :value="2" style="width:100%">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>是否预约：</span>
        <el-select v-model="search.hasAppointment" placeholder="请选择" clearable style="width:100%">
          <el-option label="是" :value="1" style="width:100%"></el-option>
          <el-option label="否" :value="0" style="width:100%">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6" class="flex">
        <span>省份：</span>
        <el-select v-model="search.sfen" placeholder="请选择" clearable style="width:100%" @change="getTblCity">
          <el-option v-for="item in provinceList" :key="item.sfid" :label="item.sfen" :value="item.sfen"
                     style="width:100%">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="flex">
        <span>城市：</span>
        <el-select v-model="search.cshi" placeholder="请选择" clearable style="width:100%" :disabled="!search.sfen">
          <el-option v-for="item in cityList" :key="item.ciid" :label="item.city" :value="item.city" style="width:100%">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12" class="flex">
        <el-button type="primary" size="medium" @click="searchBtnFun">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
        <el-button type="primary" size="medium" @click="appointBtnFun">预约</el-button>
        <el-button type="primary" size="medium" @click="orderReassignBtnFun">派单</el-button>
        <!-- <el-button size="medium" @click="exportDialogVisible = true">导出</el-button> -->
        <el-button size="medium" @click="exportNetdotData" :loading="exportFlag">导出</el-button>
      </el-col>
    </el-row>

    <SelfEleTable ref="checktableData" :tableColumns="tableColumns" :tableData="list" @selection-change="handleSelectionChange">
      <template #spmc="{ scope }">
        <div class="goodsStyle">
          <el-image style="width: 80px; height: 80px;margin-right:20px" fit="cover"
                    :src="scope.row.commodityImage"></el-image>
          <span>{{ scope.row.spmc }}</span>
        </div>
      </template>
      <template #createdDate="{ scope }">{{ scope.row.createdDate | formatDateTimeDefault }}</template>

      <!-- <template #pushPartner="{ scope }">
        <div v-if="scope.row.smsOrderNum">SMS：{{ scope.row.smsOrderNum }}</div>
        <div v-if="scope.row.yxypOrderNum">有闲有品:{{ scope.row.yxypOrderNum }}</div>
        <div v-if="scope.row.yyzsOrderNum">源园再生:{{ scope.row.yyzsOrderNum }}</div>
        <div v-if="scope.row.hhsOrderNum">嗨回收:{{ scope.row.hhsOrderNum }}</div>
      </template> -->

      <template #partnerName="{ scope }">
        <div>{{ setPartnerName(scope.row) }}</div>
      </template>
      <template #actions="{ scope }">
        <el-button type="text"
                    v-if="scope.row.cshi === '珠海市' && !scope.row.yxypOrderNum && scope.row.orderState === '待取件'"
                    @click="pushOrder(scope.row,2)">推单
        </el-button>
        <el-button type="text" @click="goEdit(scope.row.orderNum)">编辑</el-button>
        <el-button type="text" @click="exportGood(3,scope.row.orderNum)">导出</el-button>
        <el-button type="text" @click="delectUser(scope.row.orderNum)"  v-if="isShowDeleteBtn === true">删除</el-button>
      </template>
    </SelfEleTable>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum"
                     :page-size="search.pageSize" :page-sizes="[10,20,30,40,50]" :total="total">
      </el-pagination>
    </div>
    <!-- <div class="BTNList">
      <el-button type="primary" @click="PushOrderLish(1)">SMS批量推送</el-button>
      <el-button type="primary" @click="PushOrderLish(4)">嗨回收批量推送</el-button>
      <el-button type="primary" @click="PushOrderLish(3)">源园再生批量推送</el-button>
      <el-button type="primary" @click="PushOrderLish(2)">有闲有品批量推送</el-button>
    </div> -->
    <!-- <el-dialog title="订单导出" :visible.sync="exportDialogVisible" width="400px" top="32vh" center>
      <div>
        <span>温馨提示：</span>
        <div>每次只能导出一种类型订单</div>
        <div>请您选择导出的订单类型</div>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="exportGood(1)">普通订单</div>
        <div @click="exportGood(2)">网点订单</div>
      </div>
    </el-dialog> -->
    <AppointTimeSelDialog ref="appointTimeRef" @opera-success="searchBtnFun"></AppointTimeSelDialog>
    <OrderReassign ref="orderReassignRef"  @opera-success="searchBtnFun"></OrderReassign>
    <!-- 导出属性筛选 -->
    <ExportPropDialog ref="exportPropDialogRef" @confirm-export="confirmExport"></ExportPropDialog>
  </div>

</template>

<script>
import AppointTimeSelDialog from './components/AppointTimeSelDialog'
import OrderReassign from './components/OrderReassign'
import SelfEleTable from '@/components/SelfEleTable'
import ExportPropDialog from './components/ExportPropDialog'
export default {
  name: 'home',
  components: {
    AppointTimeSelDialog,
    OrderReassign,
    SelfEleTable,
    ExportPropDialog
  },
  data() {
    return {
      tableColumns: [
        {
          type: 'selection',
          width: 55,
          selectable: this.selectable,
          fixed: 'left'
        },
        {
          prop: 'spmc',
          label: '回收商品',
          width: 220,
          fixed: 'left',
          slotScoped: 'spmc'
        },
        {
          prop:'orderNum',
          label: '订单编号',
          minWidth: 150
        },
        {
          prop:'commodityNums',
          label: '旧机编号',
          minWidth: 150
        },
        {
          prop:'userTypeStr',
          label: '订单类型',
          minWidth: 100
        },
        {
          prop:'orderStateStr',
          label: '订单状态',
          minWidth: 100
        },
        {
          prop:'createdDate',
          label: '下单时间',
          minWidth: 220,
          slotScoped:'createdDate'
        },
        {
          prop:'yddh',
          label: '联系电话',
          minWidth: 200
        },
        // {
        //   prop:'pushPartner',
        //   label: '推送方',
        //   minWidth: 200,
        //   slotScoped:'pushPartner'
        // },
        {
          prop:'partnerName',
          label: '合作方',
          minWidth: 200,
          slotScoped:'partnerName'
        },
        {
          prop:'recycleRenName',
          label: '回收人员',
          minWidth: 200,
          slotScoped:'recycleRenName'
       },
        {
          prop:'actions',
          label: '操作',
          fixed: 'right',
          width: 170,
          slotScoped:'actions'
        }
      ],
      list: [],
      search: {
        orderNum: "",  //用户编号
        yddh: "",  //注册手机号
        orderState: "",//用户状态：0冻结，1可用
        createtimeTo: "", //注册时间（结束）
        createtimeFrom: "", //注册时间（开始）
        pageSize: 10,
        spid: "",
        pageNum: 1,
        userType: 2,
        partnerName: '',
        partnershipType: '',
        hasAppointment: '',
        sfen: '',
        cshi: '',
        activityTimeDataArr: [], // 创建时间
        appointmentTimeDataArr: [], // 预约时间
      },
      isEdit: false,
      listLoading: false,
      orderStateList: [
        {
          label: "待取件",
          value: "1",
        },
        {
          label: "已完成",
          value: "2",
        },
        {
          label: "已取消",
          value: "3",
        },
      ],
      goodsTypeList: [],
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [],// 所有未选中的id
      oldarr: [],
      arr: [],
      total: 0,
      exportDialogVisible: false,
      sourceList: [],
      provinceList: [],
      cityList: [],
      IdLish: [],
      // 是否显示删除按钮
      isShowDeleteBtn: true,
      // 是否禁用合作方条件
      isDisabledPartnerCondition: false,
      exportFlag: false,
    }
  },
  filters: {},
  async created() {
    // this.getList()
    console.log(this.$route, "route")
    await this.getTblSplbDalei()
    await this.getSourceList()
    await this.getTblProvince()
    if (this.$route.query.params) {
      this.search = Object.assign(this.search, this.$route.query.params)
      setTimeout(() => {
        this.getList()
      }, 500)
    }
    // 当账号为合作方时，不显示删除按钮
    const partnershipType = JSON.parse(localStorage.getItem('partnershipType'))
    if (partnershipType === 2) {
      console.log('typepe', typeof partnershipType)
      this.isShowDeleteBtn = false
      this.isDisabledPartnerCondition = true
    }
  },
  methods: {
    setPartnerName (row) {
      const {partnerName,yyzsOrderNum,smsOrderNum,yxypOrderNum,hhsOrderNum} = row
      return partnerName || yyzsOrderNum || smsOrderNum || yxypOrderNum || hhsOrderNum
    },
    searchBtnFun () {
      this.search.pageNum = 1
      this.getList()
    },
    /**
     * 原有逻辑不清晰暂不清楚，不在目前需求，不做改动，
     * 原有代码是错的，row.orderState === '待取件' 一直为false都不能选
     * return row.cshi === '珠海市' && !row.yxypOrderNum && !row.yyzsOrderNum && row.orderState === '待取件'
     * 补：条件猜测
     * row.yxypOrderNum 有值代表已经推送过有闲有品
     * row.yyzsOrderNum 有值代表已经推送过源园再生
     */
    selectable(row, index) {
      // return row.cshi === '珠海市' && !row.yxypOrderNum && !row.yyzsOrderNum && row.orderState === '待取件'
      return true
    },
    // 推送订单前判断,原有逻辑：珠海市&&待取件&&没有推送过给有闲有品&&没有推送过给源园再生=就可以推送订单
    beforePushOrderJudgeStatus () {
      const selection = this.$refs.checktableData.$refs.elTableRef.selection || []
      if (selection.length === 0) {
        this.$message.warning("请选择订单")
        return null
      }
      const orderNums = []
      let allSelOrderState = false
      for (let item of selection) {
        if (item.cshi == '珠海市' && !item.yxypOrderNum && !item.yyzsOrderNum && item.orderState == 1) {
          allSelOrderState = false
        } else {
          allSelOrderState = true
          break
        }
      }
      if (allSelOrderState) {
        this.$message.warning("您选择的订单中存在不能推送订单")
        return null
      }
      selection.forEach((item) => {
        orderNums.push(item.orderNum)
      })
      this.IdLish = orderNums
      return orderNums
    },
    // 推送订单
    PushOrderLish (type) {
      const orderNums = this.beforePushOrderJudgeStatus()
      if (!orderNums) {
        return
      }
      // if (!this.IdLish.length) {
      //   this.$message.error('请勾选订单')
      //   return
      // }
      let params = {
        type: type,
        orderNums: this.IdLish
      }
      this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/pushOrderManually`, params).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('推单成功')
          this.getList()
        }
      })
    },
    // 单条数据推单
    pushOrder(value, type) {
      console.log(value, "value")
      let arr = []
      if (typeof (value) === 'object') {
        arr.push(value.orderNum)
      } else {

      }
      let params = {
        type: type,
        orderNums: arr
      }
      this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/pushOrderManually`, params).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('推单成功')
          this.getList()
        }
      })
    },
    // 选择改变
    handleSelectionChange (val) {
      this.IdLish = val.map(item => item.orderNum) //批量单号
    },
    getTblCity() {
      this.search.cshi = ''
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.search.sfen}`,).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data
        }
      })
    },
    getTblProvince() {
      this.search.cshi = ''
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-province/getTblProvince').then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data
        }
      })
    },
    getTblSplbDalei() {
      let parmas = {
        flag: 1
      }
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei', parmas).then(res => {
        if (res.statusCode === 200) {
          this.goodsTypeList = res.data
        }
      })
    },
    // 订单来源字典
    getSourceList() {
      return this.HttpService.get('/autoapp-default-server-recovery/api/tblRecycleSource/list').then(res => {
        if (res.statusCode === 200) {
          console.log('getSourceList>>>', res.data)
          this.sourceList = res.data
        }
      })
    },
    paramsData() {
      let {
        orderNum,
        yddh,
        orderState,
        activityTimeDataArr,
        appointmentTimeDataArr,
        spid,
        userType,
        sfen,
        cshi,
        partnerName,
        partnershipType,
        hasAppointment
      } = this.search || ''
      return {
        sfen: sfen,
        cshi: cshi,
        orderNum: orderNum,  //订单编号
        yddh: yddh,  //注册手机号
        orderState: orderState,//订单状态：0冻结，1可用
        userType: userType,//订单类型
        createtimeTo: activityTimeDataArr[1] || '', //注册时间（结束）
        createtimeFrom: activityTimeDataArr[0] || '', //注册时间（开始）
        qwsmsjFrom: appointmentTimeDataArr[0] || '', //预约时间（开始）
        qwsmsjTo: appointmentTimeDataArr[1] || '', //预约时间（开始）
        spid: spid,
        partnerName,
        partnershipType,
        hasAppointment

      }
    },
    getList() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum,
      }
      this.list = [];
      this.listLoading = true;
      this.HttpService.post('/autoapp-default-server-recovery/api/tblRecycleOrder/getOrderList', Object.assign(this.paramsData(), params)).then(res => {
        if (res.statusCode === 200)
          this.total = res.total
        if (res.data.length === 0) {
          this.$dialog({
            title: '温馨提示',
            content: '未查询到结果!',
            footBtn: false,
            width: '20%',
            dialogType: 'sighicon',
          })
        } else {
          this.arr = [];
          this.list = res.data.records
          this.listLoading = false
          // res.data.records.forEach(element => {
          //   let { spmc } = element
          //   let params = {
          //     objectName: spmc === "空调" ? 'order/goods_air_conditioner.png' : spmc === "电视" ? 'order/goods_television.png' : spmc === "电脑" ? 'order/goods_computer.png' : spmc === "冰箱" ? 'order/goods_refrigerator.png' : 'order/goods_washing_machine.png'
          //   }
          //   promiseArr.push(this.getImg(element,params.objectName));
          // });
          // Promise.all(promiseArr)
          // .then(value =>{
          //   console.log(value, "所有图片加载成功");
          //   this.list = this.arr.slice(0, this.search.pageSize);
          //   this.listLoading = false;
          // })
          // .catch(err => {
          //   console.log(err, "有图片加载失败");
          //   this.listLoading = false;
          // })
        }
      })
    },
    getImg(element, objectName) {
      return new Promise((resolve, reject) => {
        this.axios({
          url: process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrlStr?objectName=${objectName}`,
          method: 'GET',
          headers: { // 设置请求头
            Authorization: this.$store.getters.token
          }
        }).then(res => {
          element.goodsImage = res.data.data;
          this.arr.push(element);
          resolve();
        })
      })
    },
    exportGood(type, id) {
      if (type === 1) {
        this.search.userType = 1
        this.export()
      } else if (type === 2) {
        this.search.userType = 2
        this.export()
      } else {
        let params = {
          orderNum: id,
          commodityNum: ''
        }
        this.global.exportExcel
        (`/autoapp-default-server-recovery/api/tblRecycleOrder/exportOrderById`, params, '订单明细表').catch((res) => {
          let blob = new Blob([res.response.data], {
            type: 'application/json',
          });
          var blobReader = new Response(blob).json();
          blobReader.then((res) => {
            this.$message.error(res.message);
          });
        });
      }
    },
    // 确认导出
    confirmExport () {
      this.exportGood(2)
    },
    exportNetdotData () {
      // this.exportGood(2)
      // this.$refs.exportPropDialogRef.openFun(2)
      // 导出
      this.exportFlag = true;
        const params = {
          ...this.search,
        };
        
        this.global
          .exportExcel(
            `autoapp-default-server-recovery/api/tblRecycleOrder/exportOrder`,
            params,
            "批量订单查询导出"
          )
          .catch((res) => {
            let blob = new Blob([res.response.data], {
              type: "application/json",
            });
            var blobReader = new Response(blob).json();
            blobReader.then((res) => {
              this.$message.error(res.message);
            });
          })
          .finally(() => {
            this.exportFlag = false;
          });
    },
    export() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum,
      }
      let title = this.search.userType === 1 ? '个人用户' : '企业用户'
      this.global.exportExcel('/autoapp-default-server-recovery/api/tblRecycleOrder/exportOrder', Object.assign(this.paramsData(), params), `${title}明细表`).catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList()
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList()
    },
    resetForm(formName) {
      this.search = this.$options.data().search
    },
    delectUser(id) {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        footBtn: false,
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          if (id)
            this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/delOrder/${id}`).then(res => {
              if (res.statusCode === 200)
                this.$message.success('删除成功')
              this.getList()
            })
        },
        onCancel: () => {
          console.log('cancel');
        }
      })

    },
    goEdit(id) {
      this.$router.push({
        path: "/order/orderEdit",
        query: {
          id: id,
          params: this.paramsData(),
          type: 'batchOrder'
        }
      });
    },
    /**
     * orderState
     * 订单状态 1 待取件 2 已完成 3 已取消
     */
    judgeIfCanAppointAndReassign () {
      const selection = this.$refs.checktableData.$refs.elTableRef.selection || []
      if (selection.length === 0) {
        this.$message.warning("请选择订单")
        return null
      }
      const orderNums = []
      const allSelOrderState = selection.find((item) => item.orderState != 1)
      if (allSelOrderState) {
        this.$message.warning("您的选择存在不是待取件订单，请选择全部都是待取件订单")
        return null
      }
      selection.forEach((item) => {
        orderNums.push(item.orderNum)
      })
      return orderNums
    },
    // 只有待取件才可以进行预约重新选择
    appointBtnFun () {
      const orderNums = this.judgeIfCanAppointAndReassign()
      if (orderNums) {
        this.$refs.appointTimeRef.openDialog(orderNums)
      }
    },
    // 只有待取件才可以进行订单改派
    orderReassignBtnFun () {
      const orderNums = this.judgeIfCanAppointAndReassign()
      if (orderNums) {
        this.$refs.orderReassignRef.openDialog(orderNums)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}

.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;

  span {
    min-width: 100px;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.btnBox {
  margin-bottom: 20px;
}

.BTNList {
}
</style>



// WEBPACK FOOTER //
// src/views/order/batchOrderGet.vue